import './index.css'
import { DesktopNavbar } from '../NavBar/Desktop/DesktopNavbar'
import {useState, useEffect, useRef} from 'react'
import "react-datepicker/dist/react-datepicker.css";
import foto1 from '../../assets/foto4.png'
import makanan1 from '../../assets/makanan1.png'
import makanan2 from '../../assets/makanan2.png'
import porto1 from '../../assets/porto1.png'
import porto2 from '../../assets/porto2.png'
import porto3 from '../../assets/porto3.png'
import porto4 from '../../assets/porto4.png'
import porto5 from '../../assets/porto5.png'
import porto6 from '../../assets/porto6.png'
import { useNavigate } from "react-router-dom";
import eventimg from '../../assets/eventimg.png'
import star from '../../assets/star.svg'
import ig from '../../assets/instagram.svg'
import fb from '../../assets/facebook.svg'
import circleback from '../../assets/circleback.svg'
import linkedin from '../../assets/linkedin.svg'
import { MenuCardDCP } from '../Card/DCPMenuCard/DCPMenuCard';
import { HomeTypeCard } from '../Card/HomeTypeCard/HomeTypeCard';
import { CSSTransition } from 'react-transition-group';
import spinner from '../../assets/spinner.gif'
import closepopup from '../../assets/closepopup.svg'
import carleft from '../../assets/carleft.svg'
import carright from '../../assets/carright.svg'
import axios from 'axios';
import { baseUrl } from '../../lib/api';

export const PageDetailChef = () => {
    const history = useNavigate()
    const firstUpdate = useRef(true);
    const firstUpdate2 = useRef(true);
    const [detail, setDetail] = useState([])
    const [longDesc, setLongDesc] = useState(false)
    const [longHistory, setLongHistory] = useState(false)
    const [standby, setstandby] = useState(true)
    const [loading, setLoading] = useState(true)
    const [porto, setPorto] = useState([])
    const [loadmore, setloadmore] = useState(false)
    const [showpopup, setshowpopup] = useState(false)
    const [index, setindex] = useState()
    const [showNavPopup, setShowNavPopup] = useState(false)

    const handleCloseAll = () => {
        setShowNavPopup(false)
    }

    const handleLoadMore = () => {
        var elem = document.getElementsByName("DCPloadmore")
        if(loadmore){
            elem.className = "DCPmygallerykontainer DCPbeforeload"
            for(let i=6;i<elem.length;i++){
                elem[i].style.display = "none"
            }
            setloadmore(false)
        }else{
            elem.className = "DCPmygallerykontainer"
            for(let i=6;i<elem.length;i++){
                elem[i].style.display = "unset"
            }
            setloadmore(true)
        }
    }

    const handleChangeIndex = (e) => {
        console.log(index)
        if(e==="minus"){
            if(index===0){
                setindex(porto.length - 1)
            }else{
                setindex(index - 1)
            }
        }else{
            if(index===(porto.length - 1)){
                setindex(0)
            }else{
                setindex(index + 1)
            }
        }
    }

    useEffect(() =>{
        window.scrollTo(0, 0)
        setLoading(true)
        const detailChefFromDB = async () => {
            try {
                const data = await callApigetDetailChef()
                const upcomingEvent = await chefEventFromDB("upcomming")
                data["upcomingEvent"] = upcomingEvent
                setDetail(data)
            } catch (error) {
                console.log("Error detailChefFromDB")
            }
        }
        const chefGalleryFromDB = async () => {
            try {
                const data = await callApigetChefGallery()
                setPorto(data)
            } catch (error) {
                console.log("Error chefGalleryFromDB")
            }
        }
        const chefEventFromDB = async (type) => {
            try {
                const data = await callApigetChefEvent(type)
                return data
            } catch (error) {
                console.log("Error chefEventFromDB")
                return []
            }
        }
        detailChefFromDB()
        chefGalleryFromDB()
        localStorage.setItem('nav', 'fnd')
    },[])

    useEffect(() => {
        if (firstUpdate2.current) {
            firstUpdate2.current = false;
        }else{
            if(detail.length !==0 && porto.length!==0){
                setLoading(false)
            }
        }
    },[detail,porto])

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
          } else {
            var elem = document.getElementById('DCPdeskripsichef');
            if(longDesc === true){
                elem.style.height = 'unset';
            }else{
                elem.style.height = "60px";
            }
          }
    },[longDesc])

    const languagesParser = (languages) => {
        if (!languages) {
            return "N/A"
        }
        languages = languages.join(', ').replace(/, ([^,]*)$/, ' and $1')
        return languages
    }

    // Use it to get year for education or expoerience
    const parseYear = (date) => {
        if (!date) {
            return "Present"
        }
        const year = date.split("-")[0]
        return year
    }

    const parseDetailChef = (detailChef) => {
        const parseEduOrExp = (arrInput) => {
            arrInput = arrInput.map((el) => {
                return {
                    institusi: el.name,
                    tahun: `${parseYear(el.start_date)} - ${parseYear(el.end_date)}`
                }
            })
            return arrInput
        }
        detailChef = detailChef.map((el) => {
            return {
                nama: el.full_name,
                // foto: el.cover_image,
                foto: foto1,
                rating: el.rating,
                deskripsi: el.biography ? el.biography : "N/A",
                menu: [
                    {jenis: "Asian", max: 6,harga: 150, 
                    food:[{nama: "Beef bulgogi", gambar: makanan1},{nama: "Yaki gyoza", gambar: makanan2}]},
                    {jenis: "Western", max: 3, harga: 200, 
                    food:[{nama: "Beef bulgogi", gambar: makanan2},{nama: "Yaki gyoza", gambar: makanan1}]}
                ],
                bahasa: el.languages,
                instagram: el.instagram ? el.instagram : "N/A",
                facebook: el.facebook ? el.facebook : "N/A",
                linkedin: el.linkedin ? el.linkedin : "N/A",
                education: [...parseEduOrExp(el.educations), ...parseEduOrExp(el.experiences)],
                upcomingEvent: [
                    {gambar: eventimg, judul: "Thanksgiving", style: "American style featuring Turkey and Sides", sisa: 10, total: 20, tanggal: "24 Feb", jam: "18:00 - 20:00", tempat: "Hotel Santika, BSD City"},
                    {gambar: eventimg, judul: "Asian Party", style: "Asian Style", sisa: 3, total: 10, tanggal: "24 Feb", jam: "18:00 - 20:00", tempat: "Hotel Santika, BSD City"}]
            }
        })
        return detailChef[0]
    }

    const callApigetDetailChef = async () => {
        try {
            const { data: res } = await axios({
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'get',
                url: `${baseUrl}chef/Chef-Taplak`
            })
            const detailChefData = [res.data]
            const parsedDetailChefData= parseDetailChef(detailChefData)
            return parsedDetailChefData
        } catch (error) {
            console.log(error)
            console.log("error getDetailChefFromDB")
            // Create error handler (pop-up or something)
        }
    }

    const parseChefGallery = (chefGallery) => {
        chefGallery = chefGallery.map((el, idx) => {
            return {
                // foto: el.image_url,
                foto: idx === 1 ? porto1 : idx === 2 ? porto2 : porto3,
                nama: el.name,
                deskripsi: el.description ? el.description : "N/A"
            }
        })
        return chefGallery
    }

    const callApigetChefGallery = async () => {
        try {
            const { data: res } = await axios({
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'get',
                url: `${baseUrl}chef/Chef-Taplak/gallery`
            })
            const chefGallery = res.data
            const parsedChefGallery= parseChefGallery(chefGallery)
            return parsedChefGallery
        } catch (error) {
            console.log("error getChefGalleryFromDB")
            // Create error handler (pop-up or something)
        }
    }

    const parseChefEvent = (chefEvent, type) => {
        let mapChefEvent = (el) => {
            return {
                id: el.id,
                // gambar: el.cover_image,
                gambar: eventimg,
                judul: el.name,
                name: el.name,
                style: el.genre,
                sisa: el.remaining_pax,
                total: el.max_pax,
                tanggal: "24 Feb",
                jam: "18:00 - 20:00",
                tempat: el.venue_location
            }
        }
        if (type) {
            mapChefEvent = (el) => {
                return {
                    gambar: eventimg,
                    judul: el.name,
                    name: el.name,
                    style: el.genre,
                    sisa: el.remaining_pax,
                    total: el.max_pax,
                    tanggal: "24 Feb",
                    jam: "18:00 - 20:00",
                    tempat: el.venue_location
                }
            }
        }
        chefEvent = chefEvent.map(mapChefEvent)
        return chefEvent
    }

    const callApigetChefEvent = async (type) => {
        try {
            let params = null
            if (type) {
                params = { type }
            }
            const { data: res } = await axios({
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'get',
                url: `${baseUrl}chef/Chef-Taplak/event`,
                params
            })
            const chefEvent = res.data
            const parsedChefEvent= parseChefEvent(chefEvent, type)
            return parsedChefEvent
        } catch (error) {
            console.log("error getChefEventFromDB")
            // Create error handler (pop-up or something)
        }
    }

    return (
        <div onClick={e => {e.stopPropagation();handleCloseAll()}} id="maincontainer" style={{minWidth:"100%", minHeight:"100vh", backgroundColor:"#111111", position:"relative", overflow:"unset"}}>
            <DesktopNavbar showPopup={showNavPopup} setShowPopup={setShowNavPopup}></DesktopNavbar>
            <img onClick={e => {e.preventDefault();e.stopPropagation();history(-1)}} className='backmobile' alt="back" src={circleback}></img>
            {
                loading?
                <img alt='loading' className='taplakLoading' src={spinner}></img>
                :
                <CSSTransition in={standby} timeout={{appear:1000,enter:2000,exit:1000}} mountOnEnter={true} appear={true} classNames="DCtrans">
                <div>
                <div className='DCPkontainer'>
                    <div className='DCPdetailchefkontainer'>
                        <div style={{backgroundImage:`url(${detail.foto})`}} className='DCPfotochef'></div>
                        <div className='DCPkontainertengah'>
                            <div className='DCPnamarate'>
                                    <p className='DCPnama'>{detail.nama}</p>
                                    <img src={star} alt="icon" className='DCPiconrate'></img>
                                    <p className='DCPrate'>{detail.rating}</p>
                                </div>
                                <div id="DCPdeskripsichef" className='DCPdeskripsichef'>
                                    {detail.deskripsi}
                                    {
                                        longDesc?
                                        <p onClick={() => setLongDesc(false)} className='DCPshowmore2'>Show Less</p>
                                        :
                                        <p onClick={() => setLongDesc(true)} className='DCPshowmore1'>Show More</p>
                                    }
                                </div>
                                <div className='mobileline'></div>
                                <div className='DCPtypelistkontainer'>
                                    <p className='DCPapa'>Type of cuisine</p>
                                    <div className='DCPtypelist'>
                                        {detail.length!==0 && (
                                            detail.menu.map((post) => {
                                                if(post.jenis === detail.menu[0].jenis){
                                                    return(<p>{post.jenis} cuisine</p>)

                                                }else{
                                                    return(<p>, {post.jenis} cuisine</p>)
                                                }
                                            })
                                        )}
                                    </div>
                                </div>

                                <div className='DCPtypelistkontainer'>
                                    <p className='DCPapa'>Spoken</p>
                                    <div className='DCPtypelist'>
                                        {detail.length!==0 && (
                                            detail.bahasa.map((post) => {
                                                if(post === detail.bahasa[0]){
                                                    return(<p>{post}</p>)
                                                }else{
                                                    return(<p>, {post}</p>)
                                                }
                                            })
                                        )}
                                    </div>
                                </div>

                                <div className='mobileline'></div>
                                
                                    {detail.length!==0 && (
                                            <div className='DCPSocialMediaContainer'>
                                                <a href={detail.instagram}><img className='DCPicon' alt="icon" src={ig}></img></a>
                                                <a href={detail.facebook}><img alt="icon" className='DCPicon' src={fb}></img></a>
                                                <a href={detail.linkedin}><img alt="icon" className='DCPicon' src={linkedin}></img></a>
                                            </div>
                                        )}

                                <div className='mobileline'></div>
                        </div>
                        <div className='DCPkontenkanandetail'>
                            <div className='DCPeducation'>Education & Work
                                {
                                    longHistory?
                                    <p onClick={() => setLongHistory(false)} className='DCPshowmore1'>Show Less</p>
                                    :
                                    <p onClick={() => setLongHistory(true)} className='DCPshowmore1'>Show More</p>
                                }
                            </div>

                            {
                                (detail.length!==0 && longHistory===false) && (
                                    <div className='mobileonly'>
                                    <p className='DCPinstitusi'>{detail.education[0].institusi}</p>
                                    <p className='DCPtahun'>{detail.education[0].tahun}</p>
                                    </div>
                                )
                            }

                            {
                                (detail.length!==0 && longHistory) && (
                                    detail.education.map((post) => (
                                        <div className='mobileonly'>
                                        <p className='DCPinstitusi'>{post.institusi}</p>
                                        <p className='DCPtahun'>{post.tahun}</p>
                                        </div>
                                    ))
                                )
                            }

                            {
                                (detail.length!==0) && (
                                    detail.education.map((post) => (
                                        <div className='desktoponly'>
                                        <p className='DCPinstitusi'>{post.institusi}</p>
                                        <p className='DCPtahun'>{post.tahun}</p>
                                        </div>
                                    ))
                                )
                            }
                            
                            <div className='mobileline'></div>
                        </div>
                    </div>
                    <p className='DCPpilihanmenu white fontbold'>My Gallery</p>

                    <div className='DCPmygallery flexwrap'>
                        {
                            porto.map((post, i) => (
                                <div name="DCPloadmore" className='DCPmygallerykontainer DCPbeforeload'>
                                    <div onClick={e => {e.preventDefault();e.stopPropagation();setindex(i);setshowpopup(true)}} style={{backgroundImage:`url(${post.foto})`}} className='DCPmygalleryimg'>
                                        <div className='DCPgradient'></div>
                                        <p className='tiny white DCPimgtext'>{post.nama}</p>
                                    </div>
                                </div>
                            ))
                        }
                        {
                            loadmore?
                                <p className='tiny' onClick={() => handleLoadMore()} style={{cursor:"pointer",marginTop:"16px",width:"100%",textAlign:"center",color:"#AAAAAA"}}>SHOW LESS</p>
                            :
                                <p className='tiny' onClick={() => handleLoadMore()} style={{cursor:"pointer",marginTop:"16px",width:"100%",textAlign:"center",color:"#AAAAAA"}}>LOAD MORE</p>
                        }
                        
                    </div>

                    <p className='DCPpilihanmenu white fontbold'>Pilihan Menu</p>
                    <div className='DCPlistpilihanmenu flexwrap'>
                        

                        <div className='DCPlistmenucard flex'>
                            {
                                detail.length!==0 && (
                                    detail.menu.map((post) => (
                                        <MenuCardDCP data={post} standby={standby} fungsi={()=>setstandby(false)} />
                                    ))
                                )
                            }
                        </div>
                        
                    </div>

                    <p className='DCPpilihanmenu white fontbold'>Upcoming Event</p>

                    

                    
                    

                </div>
                <div className="DCPupcomingkontainerList">
                {detail.length!==0 && (detail.upcomingEvent.map((post) => (
                    <HomeTypeCard
                        gambar = {post.gambar} 
                        judul = {post.judul} 
                        style = {post.style} 
                        sisa = {post.sisa} 
                        total = {post.total} 
                        tanggal = {post.tanggal} 
                        jam = {post.jam} 
                        tempat = {post.tempat}
                        fungsi={()=>setstandby(false)} 
                    />
                    )))}
                </div>
                </div>
                </CSSTransition>
                
            }
            {showpopup && (
                <div className='DCPpopupwrapper'>
                    <div onClick={e => {e.preventDefault();e.stopPropagation();setshowpopup(false)}} className='DCPqrouter'/>
                    <div className='DCPpopupkonten flex'>
                        <div className='DCPpopupkiri' style={{backgroundImage:`url(${porto[index].foto})`}}/>
                        <div className='DCPpopupkanan'>
                            <div className='DCPpopupkanankonten'>
                                <p className='semibig white'>{porto[index].nama}</p>
                                <p className='tiny white' style={{marginTop:"16px"}}>{porto[index].deskripsi}</p>
                            </div>
                        </div>
                    </div>
                    <img onClick={e => {e.preventDefault();e.stopPropagation();setshowpopup(false)}} className='DCPclosepopup' alt="close" src={closepopup}></img>
                    <img onClick={e => {e.preventDefault();e.stopPropagation();handleChangeIndex("minus")}} className='DCPleft' alt="close" src={carleft}></img>
                    <img onClick={e => {e.preventDefault();e.stopPropagation();handleChangeIndex("plus")}} className='DCPright' alt="close" src={carright}></img>
                </div>
            )}
        </div>
    )
  }